import type { Equipped } from '@cratered/shared';
import { ugcUrl } from '../ugc';
import type { MoleLook } from './mole';

/**
 * What to draw for a player's equipped cosmetics, custom art included. The race is passed on as
 * it is: absent (a profile from before races, a hand-built test loadout) means the mole to the drawing code.
 */
export function lookFor(equipped: Equipped, teamColor: string): MoleLook {
  return {
    race: equipped.race,
    body: equipped.body,
    outfit: equipped.outfit,
    teamColor,
    customBody: equipped.custom?.body ? ugcUrl(equipped.custom.body) : undefined,
    customHead: equipped.custom?.head ? ugcUrl(equipped.custom.head) : undefined,
  };
}
